// extracted by mini-css-extract-plugin
export var box = "_9i-1";
export var checked = "_9i-2";
export var descriptionSpacer = "_9i-9";
export var disabled = "_9i-3";
export var icon = "_9i-6";
export var input = "_9i-0";
export var labelSpacer = "_9i-8";
export var medium = "_9i-5";
export var small = "_9i-4";
export var text = "_9i-7";